import * as API from '@/services';
import { PayloadAction } from '@reduxjs/toolkit';
import { put } from 'redux-saga/effects';

import { formatWorkerHistoryList } from './worker-history.helper';
import { WorkerHistoryActions } from './worker-history.redux';
import { IPayloadGetWorkerHistoryListRequest } from './worker-history.type';

export function* getWorkerHistoryList(
	action: PayloadAction<IPayloadGetWorkerHistoryListRequest>
) {
	const { callback, ...rest } = action.payload;

	try {
		// call api
		const res: API.ApiResponseSuccess<API.GetWorkerHistoryListResponse> =
			yield API.getWorkerHistoryList({ ...rest });
		const content = formatWorkerHistoryList(res?.data?.content, {
			total: res?.data?.total,
			page: rest.page,
			pageSize: rest.pageSize,
		});

		yield put(
			WorkerHistoryActions.getWorkerHistoryListSuccess({
				...rest,
				content,
				total: res?.data?.total,
			})
		);
		callback?.();
	} catch (error) {
		callback?.(error);
		yield put(WorkerHistoryActions.getWorkerHistoryListFailure());
	}
}
